import { USER, ROLES, CONFIG, APP } from '../../utils/constants';
import { formatPhoneObjectToString } from '../../utils/stringUtils';
import { getItem, setItem } from '../../services/storage';

const validateUserData = (value) => {
  if (
    value &&
    value.fullName &&
    value.username &&
    value.email &&
    value.userRole
  ) {
    return true;
  }
  return false;
};

export default {
  state: {
    userData: getItem('user', validateUserData) || null,
    imobmeData: null,
  },
  getters: {
    [USER.GET_FULL]: (state) => ({
      userData: state.userData,
      imobmeData: state.imobmeData,
    }),
    [USER.GET_USER]: (state) => state.userData,
    [USER.HAS_COMPLIANCE]: (state, getters) => {
      if (getters[USER.GET_USER_ROLE] == 'admin') {
        return true;
      } else {
        if (state.userData.compliance) {
          return (
            state.userData.compliance.version ==
            getters[CONFIG.GET_COMPLIANCE].version
          );
        } else {
          return null;
        }
      }
    },
    [USER.GET_USER_POPUPS]: (state) => state.userData.popups || {},
    [USER.GET_USER_ROLE]: (state) =>
      state.userData ? state.userData.userRole : null,
    [USER.GET_IMOBME_DATA]: (state) => {
      return state.userData && state.userData.userRole === ROLES.CLIENT_ROLE
        ? state.imobmeData
        : state.userData;
    },
    [USER.GET_CELLPHONE_STRING]: (state) =>
      state.imobmeData
        ? formatPhoneObjectToString(state.imobmeData.cellphone)
        : formatPhoneObjectToString(state.userData.cellphone),
  },
  mutations: {
    [USER.MUTATE_USER]: (state, payload) => {
      state.userData = payload;
      setItem('user', payload);
    },
    [USER.MUTATE_IMOBME_DATA]: (state, payload) => {
      state.imobmeData = payload;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js